import Link from 'next/link';
import { useRouter } from 'next/router';

import { IMenuItem } from '@r1-frontend/api-domru/api-content/v2/menu/by-types/dto/IMenuByTypesItem';

import Description from '~/src/features/_layout/Header/desktop/components/MainMenuItem/components/Description';

import * as ST from './styled';

interface IProps {
    item: IMenuItem,
    onClickHandler: (menuType: 'Main' | 'Right', title: string) => void,
}

const DescriptionButton = ({ item, onClickHandler }: IProps): JSX.Element => {
    const { asPath } = useRouter();
    const { title, link, add_desc = '', button_text, button_link } = item;

    return (
        <ST.ItemWrapper isCurrent={asPath === link} onClick={() => onClickHandler('Main', title)}>
            <Link
                href={link}
                prefetch={false}
                passHref
            >
                <a>
                    <ST.ItemTitle title={title}/>
                    <Description description={add_desc}/>
                </a>
            </Link>
            {button_link && <ST.ItemBtn btnText={button_text} btnLink={button_link} data-test='subitem-btn'/>}
        </ST.ItemWrapper>
    );
};

export default DescriptionButton;
